import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCloudBlank = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 12,
	height: 12,
	viewBox: "0 0 12 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M2.62461 4.57151C3.0316 3.08908 4.3882 2 6 2C7.6118 2 8.9684 3.08908 9.37539 4.57152C10.593 4.85481 11.5 5.94625 11.5 7.25C11.5 8.76878 10.2688 10 8.75 10H3.25C1.73122 10 0.5 8.76878 0.5 7.25C0.5 5.94625 1.40695 4.85481 2.62461 4.57151Z",
		fill: "currentColor"
	})
});
export default SvgCloudBlank;
